import { Box, Typography } from "@mui/material";

export const CountryRadioGroup: React.FC<{
  label: string;
  value: "AU" | "NZ";
  onChange: (country: "AU" | "NZ") => void;
}> = ({ label, value, onChange }) => (
  <Box sx={{ display: "flex", alignItems: "center" }}>
    <Typography variant="subtitle1" fontWeight={700} style={{ marginRight: "4px" }}>
      {label}
    </Typography>
    <Box>
      <label style={{ marginRight: 8, fontWeight: value === "AU" ? 700 : 400 }}>
        <input
          type="radio"
          name={`${label}-country`}
          value="AU"
          checked={value === "AU"}
          onChange={() => onChange("AU")}
          style={{ marginRight: 4, accentColor: "#43a047" }}
        />
        AU
      </label>
      <label style={{ fontWeight: value === "NZ" ? 700 : 400 }}>
        <input
          type="radio"
          name={`${label}-country`}
          value="NZ"
          checked={value === "NZ"}
          onChange={() => onChange("NZ")}
          style={{ marginRight: 4, accentColor: "#43a047" }}
        />
        NZ
      </label>
    </Box>
  </Box>
);
